export const SESSION_TIMING_UPDATED = 'sessionTiming/updated';
export const SESSION_TIMING_CLEARED = 'sessionTiming/cleared';

/**
 * Dispatched when /ECM/session/extend responds with fresh timing data.
 * @param {{ timeoutMins: number, promptMins: number, lastRefreshedAt: number }} payload
 */
export const sessionTimingUpdated = (payload) => ({
  type: SESSION_TIMING_UPDATED,
  payload,
});

/** Dispatched on logout to reset session timing state. */
export const sessionTimingCleared = () => ({
  type: SESSION_TIMING_CLEARED,
});
